import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: () => (
    <main
      style={{
        display: "flex",
        minHeight: "100vh",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 16,
        background: "#0b0d10",
        color: "#f2f4f7",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      <img
        src="/images/taskbar-icon.png"
        alt=""
        style={{ width: 72, height: 72, borderRadius: 16 }}
      />
      <img
        src="/images/StagVista-white.png"
        alt="StagVista"
        style={{ height: 36, width: "auto" }}
      />
      <p style={{ margin: 0, opacity: 0.6, fontSize: 14 }}>Remote</p>
    </main>
  ),
});
